import type { Taxonomy } from "~/types/ecom/categories/categories.type";

export function extractCategoryMetaTitle(currentTaxonomy: Taxonomy): string {
  const metaTitle = currentTaxonomy.notes.find(
    (metaData) => metaData.name === "meta-title"
  );
  return metaTitle?.value.replace(/&amp;/g, "&") || "";
}

export function extractCategoryMetaDescription(
  currentTaxonomy: Taxonomy
): string {
  const metaDescription = currentTaxonomy.notes.find(
    (metaData) => metaData.name === "meta-description"
  );
  return metaDescription?.value || "";
}

export function slugToCategoryName(slug: string) {
  return slug.replace(/-/g, ' ').replace(/^./, char => char.toUpperCase());
}


export function getTaxonomyLocaleName(taxonomy,locale,locales) {
  if(!taxonomy){
    return "";
  }
  const currentLocale = findInArrayByKey(locales,'code',locale);
  if(!taxonomy.locales || !taxonomy.locales[currentLocale.ecom_api_code] ||
      !taxonomy.locales[currentLocale.ecom_api_code].name){
    return taxonomy.name;
  }
  return taxonomy.locales[currentLocale.ecom_api_code].name
}
